export function isSelectedInBulkActions(selectedRows, rowId) {
  return selectedRows.some((e) => e.id === rowId);
}
